import React from "react";
import { Descriptions, Empty } from "antd";
import PropTypes from "prop-types";
import styles from "./specifications-description.module.scss";

const normalizeSpecificationValue = (value) => {
    if (value === null || value === undefined || value === "") {
        return "N/A";
    }

    return value;
};

const getSpecificationItems = (specifications, hiddenSpecifications) => {
    // Canonical order (same as project details / order manager) is sort_order.
    // Rows without one keep their API position (stable sort).
    const orderedSpecifications = [...(specifications || [])]
        .map((spec, index) => ({ ...spec, __index: index }))
        .sort(
            (a, b) =>
                (a.sort_order ?? a.__index) - (b.sort_order ?? b.__index)
        );
    // View mode never keeps a key with an empty value.
    const isEmptyValue = (value) => value === null || value === undefined || value === '';
    return [...orderedSpecifications, ...(hiddenSpecifications || [])]
        .filter(Boolean)
        .filter(({ value }) => !isEmptyValue(value))
        .map(({ id, name, value }, index) => ({
            key: id ?? `${name}-${index}`,
            label: name,
            children: normalizeSpecificationValue(value),
        }));
};

const SpecificationsDescription = ({
    specifications = [],
    hiddenSpecifications = [],
    title = "Specifications",
    titleLevel = 3,
}) => {
    const items = getSpecificationItems(specifications, hiddenSpecifications);
    const TitleTag = titleLevel === 4 ? "h4" : "h3";

    return (
        <section className={styles.wrapper}>
            {title && <TitleTag className={styles.title}>{title} :</TitleTag>}
            {items.length ? (
                <Descriptions
                    bordered
                    colon={false}
                    column={1}
                    className={styles.descriptions}
                    items={items}
                    size="small"
                />
            ) : (
                <Empty
                    className={styles.empty}
                    description="No specifications available"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
            )}
        </section>
    );
};

SpecificationsDescription.propTypes = {
    specifications: PropTypes.arrayOf(PropTypes.object),
    hiddenSpecifications: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string,
    titleLevel: PropTypes.oneOf([3, 4]),
};

export default SpecificationsDescription;
